import React from 'react';
import { connect } from 'react-redux'
import { compose } from 'recompose';

const CurrentUser = ({user}) => {
    return (
        <div className="accountName">
            {user.displayName}
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.user.currentUser
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
    }
};

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
)(CurrentUser);




// WEBPACK FOOTER //
// ./src/components/currentUser/CurrentUser.js